module.exports = __webpack_public_path__ + "img/my-vip.bc7c4e8f.png";